<!--
 * @Description: 开通
 * @Author: ChenXueLin
 * @Date: 2021-11-25 15:58:30
 * @LastEditTime: 2022-05-11 11:05:36
 * @LastEditors: LiangYiNing
-->
<template>
  <div>
    <div class="task-list-content">
      <detail-table-title @resize="handleTableTitleResize" :showSearch="false">
        <template v-slot:title>
          任务项
        </template>
        <template v-slot:btns>
          <el-button
            type="primary"
            @click="handleOpen(1)"
            v-if="
              (basicInfo.serviceStatusCode == 1 ||
                basicInfo.serviceStatusCode == 2) &&
                basicInfo.hasRight == 1
            "
            >同意开通</el-button
          >
          <el-button
            type="primary"
            @click="handleOpen(2)"
            v-if="
              (basicInfo.serviceStatusCode == 1 ||
                basicInfo.serviceStatusCode == 2) &&
                basicInfo.hasRight == 1
            "
            >拒绝开通</el-button
          >
          <el-button
            type="primary"
            @click="openSim"
            v-if="
              (basicInfo.serviceStatusCode == 1 ||
                basicInfo.serviceStatusCode == 2) &&
                basicInfo.hasRight == 1
            "
            >开通SIM卡</el-button
          >
        </template>
      </detail-table-title>
      <!-- 表格 -->
      <el-table
        border
        height="300px"
        :data="tableData"
        highlight-current-row
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        :row-key="
          row => {
            return row.id;
          }
        "
      >
        <el-table-column
          type="selection"
          :selectable="checkSelectable"
          :reserve-selection="true"
          width="50"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="50"
          fixed="left"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{
                scope.$index +
                  1 +
                  (searchForm.pageIndex - 1) * searchForm.pageSize
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(column, index) in columnData"
          :key="index"
          :prop="column.fieldName"
          :label="column.fieldLabel"
          :min-width="column.width"
          :fixed="column.fixed"
          :align="column.align"
          header-align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="column.fieldName === 'sceneName'">
              {{ row.show ? row[column.fieldName] : "" }}
            </span>
            <span v-else-if="column.fieldName === 'sceneType'">
              {{ row.show ? row[column.fieldName] : "" }}
            </span>
            <span v-else-if="column.fieldName === 'isChangeCard'">
              <e6-vr-select
                v-if="row.type == 1"
                :data="isChangeList"
                :is-title="true"
                v-model="row.isChangeCard"
                clearable
                allow-create
                :disabled="row.taskItemStatusCode != 1"
              >
              </e6-vr-select>
            </span>
            <span v-else>{{ row[column.fieldName] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 start -->
      <section class="pagination-wrapper fixed-section">
        <el-pagination
          :page-size.sync="searchForm.pageSize"
          :current-page.sync="searchForm.pageIndex"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </section>
      <!-- 分页 end -->
    </div>
    <!-- 任务项 end -->
    <!--拒绝开通弹框  -->
    <el-dialog
      v-dialogDrag
      title="拒绝开通"
      :visible="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
      :element-loading-background="loadingBackground"
      :before-close="handleClose"
      custom-class="custom-dialog"
    >
      <el-form
        :inline="true"
        label-width="120"
        :model="refuseForm"
        :rules="refuseFormRules"
        ref="refuseForm"
      >
        <el-form-item label="拒绝原因" prop="remark">
          <el-input
            placeholder="拒绝原因"
            v-model="refuseForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button class="cancel" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/mixins/base";
import listPage from "@/mixins/list-page";
import listPageReszie from "@/mixins/list-page-resize";
import DetailTableTitle from "@/components/detailTableTitle.vue";
import { openColumn } from "../../tableColumnData";
import { getOpenService, agreeOpen, updateSim } from "@/api";
import { printError } from "@/utils/util";
import eventBus from "@/bus";
export default {
  name: "repairService",
  data() {
    return {
      loading: true,
      tableData: [],
      searchForm: {
        pageIndex: 1,
        pageSize: 20
      },
      columnData: openColumn,
      total: 0,
      selColumn: [], //勾选的任务项
      /******同意/拒绝开通************/
      agreeList: [], //需要换卡的任务项
      refusedList: [], //不需要换卡的任务项
      isChangeList: [
        {
          id: 0,
          label: "否"
        },
        {
          id: 1,
          label: "是"
        }
      ], //是否换卡下拉框数据
      openType: 1, //1同意2拒绝
      dialogVisible: false,
      refuseForm: {
        remark: ""
      },
      refuseFormRules: {
        remark: [
          {
            required: true,
            message: "请输入拒绝原因",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  props: ["serviceId", "corpId", "corpName", "basicInfo"],
  mixins: [base, listPage, listPageReszie],
  computed: {},
  components: {
    DetailTableTitle
  },
  watch: {},
  created() {
    this.getOpenServiceReq();
  },
  methods: {
    //查询开通任务项列表
    async getOpenServiceReq() {
      try {
        this.loading = true;
        let res = await getOpenService({
          serviceId: this.serviceId,
          ...this.searchForm
        });
        let tableData = res.data.array;
        for (let i = 0; i < tableData.length; i++) {
          if (i == 0) {
            tableData[i].show = true;
          } else {
            if (tableData[i].sceneName == tableData[i - 1].sceneName) {
              tableData[i].show = false;
            } else {
              tableData[i].show = true;
            }
          }
        }
        this.tableData = tableData;
        this.total = res.data.totalRecords;
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //勾选任务项
    handleSelectionChange(val) {
      this.selColumn = val;
    },
    //点击开通SIM卡
    openSim() {
      if (!this.selColumn.length) {
        this.$message.warning("请选择要开通的SIM卡");
        return;
      }
      this.openSimReq();
    },
    //待处理状态才能进行处理
    checkSelectable(row) {
      return row.taskItemStatusCode == 1;
    },
    //开通sim卡请求
    async openSimReq() {
      try {
        this.loading = true;
        let res = await updateSim({
          type: 5, //2激活，4报停，5开通
          simNo: this.selColumn.map(item => {
            return item.simNo;
          })
        });
        if (res.code == "OK") {
          this.$message.success(res.msg);
          this.selColumn = [];
          this.$refs.multipleTable.clearSelection();
          eventBus.$emit("refresh");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //点击同意/拒绝变更
    handleOpen(openType) {
      if (!this.selColumn.length) {
        this.$message.warning("请先选择任务项");
        return;
      }
      this.openType = openType;
      if (openType == 1) {
        //同意
        //选择是
        this.agreeList = this.selColumn.filter(item => {
          return item.isChangeCard == 1;
        });
        //选择否
        this.refusedList = this.selColumn.filter(item => {
          return item.isChangeCard == 0;
        });
        // 否：点击同意开通后，任务项状态变为进行中
        if (this.refusedList.length) {
          this.handleAgreeOpen();
        } else {
          //是：点击同意开通后，跳到【创建任务单-维修】页
          if (this.agreeList.length) {
            // let queryData = JSON.stringify(this.basicInfo);
            let ids = this.agreeList.map(item => {
              let obj = {
                equipId: item.equipId,
                id: item.id
              };
              return obj;
            });
            let equipList = JSON.stringify(ids);
            this.routerPush({
              name: "taskListManage/addRepairOrder",
              params: {
                refresh: true,
                equipList,
                serviceId: this.basicInfo.serviceId,
                queryType: 1
              }
            });
          }
        }
      } else {
        //拒绝
        this.agreeList = [];
        this.refusedList = [];
        this.dialogVisible = true;
      }
    },
    //开通处理请求
    async handleAgreeOpen() {
      try {
        this.loading = true;
        let selColumnIds = [];
        //如果需要换卡有值，先处理不需要换卡的任务项
        if (this.openType == 1) {
          //开通操作
          selColumnIds = this.refusedList.map(item => {
            return item.id;
          });
        } else {
          //拒绝操作
          selColumnIds = this.selColumn.map(item => {
            return item.id;
          });
        }
        let res = await agreeOpen({
          serviceId: this.serviceId,
          ...this.refuseForm,
          type: this.openType,
          taskItemIds: selColumnIds
        });
        if (res.code == "OK") {
          if (this.agreeList.length) {
            let queryData = JSON.stringify(this.basicInfo);
            this.routerPush({
              name: "taskListManage/addRepairOrder",
              params: {
                refresh: true,
                equipList: this.agreeList,
                queryData
              }
            });
          } else {
            this.$message.success("操作成功");
            this.getOpenServiceReq();
            this.selColumn = [];
            this.$refs.multipleTable.clearSelection();
            if (this.openType == 2) {
              this.handleClose();
            }
            eventBus.$emit("refresh");
          }
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    /*****同意/拒绝变更**********/
    confirm() {
      this.$refs.refuseForm.validate(valid => {
        if (valid) {
          this.handleAgreeOpen();
        }
      });
    },

    //关闭弹框
    handleClose() {
      this.refuseForm = {
        remark: ""
      };
      this.$refs.refuseForm.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.custom-dialog {
  .el-dialog__body {
    padding: 20px;
    .title {
      margin-bottom: 15px;
    }
    .el-input {
      width: 280px;
    }
  }
}
</style>
